import React from "react";

import { faBriefcase } from "@fortawesome/pro-solid-svg-icons/faBriefcase";
import { useIntl } from "react-intl";

import { Activity, Resource } from "@mapmycustomers/shared/types/entity";

import Section from "../Section";

import ResourceItem from "./ResourceItem";
import styles from "./ResourcesSection.module.scss";

interface ResourcesSectionProps {
  activity: Activity;
  resources: Resource[];
}

const ResourcesSection = ({ activity, resources }: ResourcesSectionProps) => {
  const intl = useIntl();

  if (!resources.length) {
    return null;
  }

  return (
    <Section
      icon={faBriefcase}
      title={intl.formatMessage({
        id: "component.activityAnnotation.resourcesSection.title",
        defaultMessage: "Resources",
        description: "Title for activity resources section",
      })}
    >
      <div className={styles.resourceItems}>
        {resources.map((resource) => {
          return <ResourceItem activity={activity} key={resource.id} resource={resource} />;
        })}
      </div>
    </Section>
  );
};

export default ResourcesSection;
